import { AnimatePresence, motion } from "framer-motion";
import React, { FC, useState } from "react";
import { useHistory } from "react-router-dom";
import checkoutbox from "../../assets/images/checkoutbox.svg";
import expand from "../../assets/images/expand.svg";
import minimize from "../../assets/images/minimize.svg";

export const GetStarted: FC<{}> = () => {
  const { push } = useHistory();
  return (
    <motion.div layout className="getStarted-section">
      <div className="container">
        <div>
          <div className="row">
            <div className="col-12 col-lg-6">
              <div className="content">
                <motion.div layoutId="heading" className="heading">
                  <h2>
                    Perform Your First Transaction On <span>Speednance.</span>
                  </h2>
                </motion.div>
                <div>
                  <motion.div layout className="steps">
                    {steps.map((step: Step) => {
                      return (
                        <Step
                          title={step.title}
                          body={step.body}
                          key={step.title}
                        />
                      );
                    })}
                    <div className="getStarted-btn">
                      <motion.button
                        layoutId="button"
                        onClick={() => push("/register")}
                      >
                        Place first order
                      </motion.button>
                    </div>
                  </motion.div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6 d-none d-lg-block">
              <motion.img layoutId="image" src={checkoutbox} alt="" />
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

interface StepProps {
  title: string;
  body: string;
}
const Step: FC<StepProps> = ({ title, body }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <motion.div className="step" layout>
      <motion.div layout className="title">
        <h1>{title}</h1>
        <button onClick={toggleOpen}>
          <img src={isOpen ? minimize : expand} alt="" />
        </button>
      </motion.div>
      <AnimatePresence exitBeforeEnter>
        {isOpen && <Content body={body} />}
      </AnimatePresence>
    </motion.div>
  );
};

interface ContentProps {
  body: string;
}

export const Content: FC<ContentProps> = ({ body }) => {
  return (
    <motion.div
      layout
      initial={{ opacity: 0 }}
      className="body"
      animate={{ opacity: 1, transition: { delay: 0.2 } }}
      exit={{ opacity: 0 }}
    >
      <p>{body}</p>
    </motion.div>
  );
};

interface Step {
  title: string;
  body: string;
}
const steps: Readonly<Array<Step>> = [
  {
    title: "Sign Up",
    body:
      "It takes few steps and few seconds to signup. click on the Place first Order button below to sign up and move to the next step.",
  },
  {
    title: "Place an Order",
    body:
      "After being logged in, place a buy or sell order on the buy or sell page. Fill the KYC form, view your order summary and place your order",
  },
  {
    title: "Make Payments",
    body: `After placing an order, pay for your order to the payments info provided. 
    Go to the orders page and click on your order to show the payment verification box.
     Fill the form to submit your payment verification`,
  },
  {
    title: "Receive Order",
    body:
      "After submitting your payment verification, sit tight and wait for the admins to verify your payments and process your order. You'll get your order in no time",
  },
];
